import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Col, Row, message, Select } from "antd";
import { API_METHODS, BLANK_VALUE } from "../../../constants";
import useApi from "../../../hooks/useApi";
function AddSubcategory(props) {
  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();
  const { visible, close, selectedRecord } = props;
  const [response, request] = useApi(
    "/config/subcategory",
    null,
    API_METHODS.POST
  );
  const [editResponse, editRequest] = useApi(
    `/config/subcategory/${selectedRecord && selectedRecord.id}`,
    null,
    API_METHODS.PUT
  );
  const [categoryResponse, categoryRequest] = useApi(
    "/config/category/dropdown",
    null,
    API_METHODS.GET
  );
  const [categories, setcategories] = useState([]);

  useEffect(() => {
    categoryRequest();
  }, []);

  useEffect(() => {
    if (response.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Subcategory added successfully.",
      });
    }
  }, [response]);

  useEffect(() => {
    if (editResponse.data) {
      close(true);
      messageApi.open({
        type: "success",
        content: "Subcategory updated successfully.",
      });
    }
  }, [editResponse]);

  useEffect(() => {
    if (selectedRecord) {
      form.setFieldsValue(selectedRecord);
    }
  }, [selectedRecord]);

  useEffect(() => {
    const data =
      categoryResponse.data !== BLANK_VALUE ? categoryResponse.data : [];
    setcategories(data);
  }, [categoryResponse]);

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (selectedRecord) {
          editRequest(values);
        } else {
          request(values, API_METHODS.POST);
        }
      })
      .catch((e) => {});
  };

  const handleCancel = () => {
    close();
  };

  return (
    <Modal
      title={selectedRecord ? "Update Subcategory" : "Add Subcategory"}
      open={visible}
      onOk={handleOk}
      onCancel={handleCancel}
      width={1000}
      okText="Save"
    >
      {contextHolder}
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              name="subcategory"
              label="Subcategory"
              rules={[
                { required: true, message: "Subcategory is required." },
                {
                  max: 200,
                  message: "Subcategory should be maximum of 200 characters.",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="category_id"
              label="Category"
              rules={[{ required: true, message: "Category is required." }]}
            >
              <Select
                allowClear
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {categories?.map((option) => (
                  <Select.Option key={option.id} value={option.id}>
                    {option.category}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="banner_text"
              label="Banner Text"
              rules={[{ required: true, message: "Banner Text is required." }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default AddSubcategory;
